import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate
    {...props}
    team="Los Angeles Chargers"
    teamShort="Chargers"
    teamId={teamIds['Los Angeles Chargers']}
  />
)
